class FilterCollection extends HTMLElement {
  constructor() {
    super();

    this.container = this;

    this.select = this.container.querySelector('.js-filter-collection');
    this.itemsList = document.querySelector('.collection-list');

    if (this.select && this.itemsList) {
      this.select.addEventListener('change', () => this.update());

      this.clearFilter = this.container.querySelector('.js-collection-filter-all');
      if (this.clearFilter) {
        this.clearFilter.addEventListener('click', () => this.clear());
      }
    }
  }

  update() {
    this.value = this.select.value;

    this.itemsList.classList.add('is-filter');
    if (this.itemsList.querySelectorAll('.collection-list-item.show-filter').length > 0) {
      this.itemsList.querySelector('.collection-list-item.show-filter').classList.remove('show-filter');
    }
    this.itemsList.querySelector('.collection-list-item[data-id="' + this.value + '"]').classList.add('show-filter');
  }

  clear() {
    this.select.value = this.select.options[0].text;

    if (this.itemsList.classList.contains('is-filter')) {
      this.itemsList.classList.remove('is-filter');
    }
    if (this.itemsList.querySelectorAll('.collection-list-item.show-filter').length > 0) {
      this.itemsList.querySelector('.collection-list-item.show-filter').classList.remove('show-filter');
    }
  }
}

customElements.define("filter-collection", FilterCollection);